import { render, staticRenderFns } from "./ShopifyAddToCartButton.vue?vue&type=template&id=6850b196"
import script from "./ShopifyAddToCartButton.vue?vue&type=script&lang=js"
export * from "./ShopifyAddToCartButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports